import { datadogRum } from "@datadog/browser-rum";
import { LOCKED_STATUS_CODE } from "../components/admin/Settings/consts";
import { UNAUTHORIZED_STATUS_CODE } from "./tokenRefresh.consts";

// tokenRefresh is loaded lazily inside the handler: its module graph reaches the app
// store, whose slices import service modules that register this interceptor at init —
// a top-level import here would make that cycle order-sensitive.
export const setResponseErrorInterceptor = (axiosInstance) => {
  axiosInstance.interceptors.response.use(
    response => response,
    async (error) => {
      if (error?.response?.status === LOCKED_STATUS_CODE) {
        datadogRum.addError(error);
        setTimeout(() => {
          window.location.reload();
        }, 1000); // Delay of 1 second
        return Promise.reject(error);
      }

      const originalConfig = error?.config;
      if (error?.response?.status === UNAUTHORIZED_STATUS_CODE && originalConfig && !originalConfig.isRetryAfterTokenRefresh) {
        try {
          const { refreshAccessToken } = await import("./tokenRefresh");
          const failedToken = originalConfig.headers?.Authorization?.replace("Bearer ", "");
          const accessToken = await refreshAccessToken({ failedToken });
          if (accessToken && accessToken !== failedToken) {
            originalConfig.isRetryAfterTokenRefresh = true;
            return axiosInstance(originalConfig);
          }
        } catch (refreshError) {
          console.error("Failed to refresh access token after unauthorized response:", refreshError);
        }
      }

      datadogRum.addError(error);
      return Promise.reject(error);
    }
  );
};
